// import { IUserResponse } from '../../models/UserModels';
import { IRowsData } from '../../pages/Migrate/DiscoverTab/EditableTable';
import {
  IGetSourceDataPayload,
  IMigrateVMPayload,
  ISourceDataPayload,
  ITargetDataPayload,
} from '../models/ConfigureArchitectureModels';
import { API_ROUTE } from './ApiRoute';
import ApiService from './ApiService';
import ApiServiceBase from './ApiServiceBase';
import { ServerType, ServiceType } from './ServiceType.data';

const serviceType = ServiceType.None;

export class ConfigureArchitectureService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.sap);

  public sendSourceTableData(payload: ISourceDataPayload): Promise<IRowsData[]> | IRowsData[] {
    return this.service.post({ route: [API_ROUTE.SOURCE] }, payload);
  }
  public getSourceTableData(payload: IGetSourceDataPayload): Promise<IRowsData[]> | IRowsData[] {
    return this.service.get({
      route: [API_ROUTE.SOURCE],
      query: { projectId: payload.projectId, clientId: payload.clientId },
    });
  }
  public updateSourceTableData(payload: IGetSourceDataPayload): Promise<IRowsData[]> | IRowsData[] {
    return this.service.put(
      {
        route: [API_ROUTE.SOURCE],
      },
      payload,
    );
  }
  public sendTargetTableData(payload: ITargetDataPayload): Promise<IRowsData[]> | IRowsData[] {
    return this.service.post({ route: [API_ROUTE.TARGET] }, payload);
  }
  public getTargetTableData(payload: ITargetDataPayload): Promise<IRowsData[]> | IRowsData[] {
    return this.service.get({
      route: [API_ROUTE.TARGET],
      query: { projectId: payload.projectId, clientId: payload.clientId },
    });
  }
  public updateTargetTableData(payload: ITargetDataPayload): Promise<IRowsData[]> | IRowsData[] {
    return this.service.put(
      {
        route: [API_ROUTE.TARGET],
      },
      payload,
    );
  }
  public getSummaryData(payload: ISourceDataPayload): Promise<IRowsData[]> | IRowsData[] {
    return this.service.get({
      route: [API_ROUTE.SUMMARY],
      query: { projectId: payload.projectId, clientId: payload.clientId },
    });
  }
  public migrateVM(payload: IMigrateVMPayload): Promise<IRowsData[]> | IRowsData[] {
    return this.service.post(
      {
        route: [API_ROUTE.MIGRATE_VM],
      },
      payload,
    );
  }
}

const configureArchitectureService = new ConfigureArchitectureService();
export default configureArchitectureService;
